import Clarity from '@microsoft/clarity'

import { Environment } from '@/model/entities/app-config.interface'

export const LoadClarity = (environment: Environment, projectId?: string): void => {
  if (environment !== 'prod' || !projectId) return
  try {
    Clarity.init(projectId)
  } catch (error) {
    console.error('Failed to initialize Microsoft Clarity:', error)
  }
}
